import React from 'react';

export default function FieldViewForUser_PopoverMenuMore() {

    const url = gd.utils.helpUrl("my_work.view_for")

    return (
        <div className="help">
            <div className="flex-row-left-center flex-wrap">
                <div className="ui5-txt-not-important-small m-r-5">
                    Users you have Manager Access to
                </div>
                <a href={url} target="_blank">Learn more</a>
            </div>
        </div>
    );
}
